import { useState, useEffect, useCallback } from 'react';

const useToggler = (
    isActive: boolean
): [boolean, (nextValue?: boolean) => void] => {
    const [value, setValue] = useState<boolean>(isActive);

    const toggle = useCallback((nextValue?: boolean) => {
        if (typeof nextValue === 'boolean') {
            setValue(nextValue);
        } else {
            setValue(currentValue => !currentValue);
        }
    }, []);

    useEffect(() => {
        setValue(isActive);
    }, [isActive]);

    return [value, toggle];
};

export default useToggler;
